<template>
	<div>
		<div class="text-center text-muted font-size-14 my-2" v-if="isLoading">
			<loading-panel loading-text="Загрузка отчета"/>
		</div>
		<div>
			<table v-if="!isLoading" class="font-size-14 table table-responsive table-bordered table-sm report-table bg-white shadow-sm">				
				<thead class="small-text">
					<tr>
						<td rowspan="4"></td>
						<td rowspan="4">Численность инспекторов</td>
						<td colspan="5">Количество  протоколов</td>
						<td colspan="5">Наложено штрафов</td>
						<td colspan="5">Взыскано штрафов*</td>
						<td colspan="2">Сумма предъявленного ущерба, тыс. руб.</td>
						<td colspan="2">Сумма взысканного ущерба**, тыс. руб.</td>
						<td colspan="2" rowspan="4">Направлено материалов на рассмотрение в следственные органы, дел/чел.</td>
						<td colspan="2" rowspan="4">Возбуждено уголовных дел по направленным материалам, дел/чел.</td>
						<td colspan="4" rowspan="2">Изъято, арестовано</td>
					</tr>
					<tr>
						<td rowspan="3">Всего</td>
						<td colspan="4" rowspan="2">В том числе, по статьям КоАП РФ:</td>
						<td rowspan="3">Всего</td>
						<td colspan="4" rowspan="2">В том числе, по статьям КоАП РФ:</td>
						<td rowspan="3">Всего</td>
						<td colspan="4" rowspan="2">В том числе, по статьям КоАП РФ:</td>
						<td rowspan="3">Всего</td>
						<td rowspan="3">В том числе, за нарушения в области рыболовства</td>
						<td rowspan="3">Всего</td>
						<td rowspan="3">В том числе, за нарушения в области рыболовства</td>
					</tr>
					<tr>
						<td rowspan="2">ВБР***, т </td>
						<td colspan="2">Орудий лова, ед.</td>
						<td rowspan="2">Транспортных средств, лодочных моторов, ед.</td>
					</tr>
					<tr>
						<td class="vertical-text small-text">Нарушения в области рыболовства</td>
						<td class="vertical-text small-text">Нарушения в области сохранения ВБР</td>
						<td class="vertical-text small-text">Нарушения посягающие на органы гос. власти</td>
						<td class="vertical-text small-text">Нарушения правил безопасности на водном транспорте</td>
						<td class="vertical-text small-text">Нарушения в области рыболовства</td>
						<td class="vertical-text small-text">Нарушения в области сохранения ВБР</td>
						<td class="vertical-text small-text">Нарушения посягающие на органы гос. власти</td>
						<td class="vertical-text small-text">Нарушения правил безопасности на водном транспорте</td>
						<td class="vertical-text small-text">Нарушения в области рыболовства</td>
						<td class="vertical-text small-text">Нарушения в области сохранения ВБР</td>
						<td class="vertical-text small-text">Нарушения посягающие на органы гос. власти</td>
						<td class="vertical-text small-text">Нарушения правил безопасности на водном транспорте</td>
						<td>Сетных орудий лова</td>
						<td>Других орудий лова</td>
					</tr>
					<tr class="font-size-11">
						<td>1</td>
						<td>2</td>
						<td>3</td>
						<td>3.1</td>
						<td>3.2</td>
						<td>3.3</td>
						<td>3.4</td>
						<td>4</td>
						<td>4.1</td>
						<td>4.2</td>
						<td>4.3</td>
						<td>4.4</td>
						<td>5</td>
						<td>5.1</td>
						<td>5.2</td>
						<td>5.3</td>
						<td>5.4</td>
						<td>6</td>
						<td>6.1</td>
						<td>7</td>
						<td>7.1</td>
						<td>8.1</td>
						<td>8.2</td>
						<td>9.1</td>
						<td>9.2</td>
						<td>10</td>
						<td>11</td>
						<td>12</td>
						<td>13</td>
					</tr>
				</thead>
				<tbody>
					<tr v-if="form_data">
						<td>
							За отчетный период
						</td>
						<td>
							{{ form_data.inspectors }}
						</td>
						<td>
							{{ form_data.protocols_count.total }}
						</td>
						<td>
							{{ form_data.protocols_count.fishing }}
						</td>
						<td>
							{{ form_data.protocols_count.vbr }}
						</td>
						<td>
							{{ form_data.protocols_count.authority}}
						</td>
						<td>
							{{ form_data.protocols_count.safety }}
						</td>
						<td>
							{{ form_data.penalty_issued.total }}
						</td>
						<td>
							{{ form_data.penalty_issued.fishing }}
						</td>
						<td>
							{{ form_data.penalty_issued.vbr }}
						</td>
						<td>
							{{ form_data.penalty_issued.authority}}
						</td>
						<td>
							{{ form_data.penalty_issued.safety }}
						</td>
						<td>
							{{ form_data.penalty_collected.total }}
						</td>
						<td>
							{{ form_data.penalty_collected.fishing }}
						</td>
						<td>
							{{ form_data.penalty_collected.vbr }}
						</td>
						<td>
							{{ form_data.penalty_collected.authority}}
						</td>
						<td>
							{{ form_data.penalty_collected.safety }}
						</td>
						<td>
							{{ form_data.damage_sum_claimed.total }}
						</td>
						<td>
							{{ form_data.damage_sum_claimed.fishery_violations }}
						</td>
						<td>
							{{ form_data.damage_sum_collected.total }}
						</td>
						<td>
							{{ form_data.damage_sum_collected.fishery_violations }}
						</td>
						<td>
							{{ form_data.sent_to_consideration.cases }}
						</td>
						<td>
							{{ form_data.sent_to_consideration.persons }}
						</td>
						<td>
							{{ form_data.opened_criminal_cases.cases }}
						</td>
						<td>
							{{ form_data.opened_criminal_cases.persons }}
						</td>
						<td>
							{{ form_data.arrested.vbr }}
						</td>
						<td>
							{{ form_data.arrested.net_fishing_gears }}
						</td>
						<td>
							{{ form_data.arrested.other_fishing_gears }}
						</td>
						<td>
							{{ form_data.arrested.vehicles }}
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr v-if="cumulative_data">
						<td>
							Нарастающий итог
						</td>
						<td>
							-
						</td>
						<td>
							{{ cumulative_data.protocols_count.total }}
						</td>
						<td>
							{{ cumulative_data.protocols_count.fishing }}
						</td>
						<td>
							{{ cumulative_data.protocols_count.vbr }}
						</td>
						<td>
							{{ cumulative_data.protocols_count.authority}}
						</td>
						<td>
							{{ cumulative_data.protocols_count.safety }}
						</td>
						<td>
							{{ cumulative_data.penalty_issued.total }}
						</td>
						<td>
							{{ cumulative_data.penalty_issued.fishing }}
						</td>
						<td>
							{{ cumulative_data.penalty_issued.vbr }}
						</td>
						<td>
							{{ cumulative_data.penalty_issued.authority}}
						</td>
						<td>
							{{ cumulative_data.penalty_issued.safety }}
						</td>
						<td>
							{{ cumulative_data.penalty_collected.total }}
						</td>
						<td>
							{{ cumulative_data.penalty_collected.fishing }}
						</td>
						<td>
							{{ cumulative_data.penalty_collected.vbr }}
						</td>
						<td>
							{{ cumulative_data.penalty_collected.authority}}
						</td>
						<td>
							{{ cumulative_data.penalty_collected.safety }}
						</td>
						<td>
							{{ cumulative_data.damage_sum_claimed.total }}
						</td>
						<td>
							{{ cumulative_data.damage_sum_claimed.fishery_violations }}
						</td>
						<td>
							{{ cumulative_data.damage_sum_collected.total }}
						</td>
						<td>
							{{ cumulative_data.damage_sum_collected.fishery_violations }}
						</td>
						<td>
							{{ cumulative_data.sent_to_consideration.cases }}
						</td>
						<td>
							{{ cumulative_data.sent_to_consideration.persons }}
						</td>
						<td>
							{{ cumulative_data.opened_criminal_cases.cases }}
						</td>
						<td>
							{{ cumulative_data.opened_criminal_cases.persons }}
						</td>
						<td>
							{{ cumulative_data.arrested.vbr }}
						</td>
						<td>
							{{ cumulative_data.arrested.net_fishing_gears }}
						</td>
						<td>
							{{ cumulative_data.arrested.other_fishing_gears }}
						</td>
						<td>
							{{ cumulative_data.arrested.vehicles }}
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	props: [
		'kndform01id',
		'department',
	],
	data () {
		return {
			moment: moment,
			isLoading: false,
			knd_form_01: null,
			expandText: false,
			form_data: null,
			cumulative_data: null
		}
	},
	components: {
	},
	computed: {
	},
	mounted () {
		this.fetchData()
	},
	methods: {
		refetch () {
			this.fetchData();
		},
		fetchData () {
			if (this.isLoading) {
				return false
			}

			this.isLoading = true

			var url = ''

			if (this.kndform01id) {
				url = process.env.VUE_APP_API_ROOT + '/api/knd/knd_forms_01/' + this.$route.params.departmentid + '/' + this.$route.params.year + '/' + this.$route.params.month + '/' + this.kndform01id
			}

			if (!url) {
				return false
			}

			let params = []

			this
				.$http
				.get(url)
				.then(res => {
					this.form_data = res.data.knd_form_01.form_data
					this.cumulative_data = res.data.cumulative_data
				})
				.catch(err => {
					this.$notify({
					  group: 'main',
					  text: 'Ошибка загрузки',
					  duration: 3000,
					  type: 'alert-danger'
					})
				})
				.then(() => {
					this.isLoading = false
				})
		},
		openModal () {
			this.$refs.newRowModal.show()
		},
		onHideModal () {
			this.$refs.newRowModal.hide()
		}
	},
	watch: {
	}
}
</script>

<style>
	.report-table {
		font-size: 14px;
	}
	.report-table thead th {
		border-bottom: none;
		text-align: center;
		font-weight: 400;
		vertical-align: middle;
		padding: 4px 8px;
	}
	.vertical-text {
		writing-mode: vertical-lr;
		text-orientation: mixed;
	}
	.small-text {
		font-size: 11px;
	}
</style>